(() => {
  if (customElements.get('sz-experience')) return;
  const button = (text, className = '') => { const e = document.createElement('button'); e.type = 'button'; e.textContent = text; e.className = className; return e; };
  const indexOf = (p, re) => p.options.findIndex(o => re.test(o));
  const sizeIndex = p => indexOf(p, /size|pointure|taille|مقاس/i);
  const colourIndex = p => indexOf(p, /colou?r|couleur|لون/i);
  const unique = values => [...new Set(values)];
  const namedColours = p => {
    const ci=colourIndex(p);
    if(ci>=0)return unique(p.variants.map(v=>v.options[ci]));
    // This shop lists many colourways as separate products. Only use explicit colour words.
    const words=p.title.match(/\b(black|white|grey|gray|silver|beige|ivory|blue|navy|pink|red|green|brown|cream|yellow|purple|orange)\b/gi)||[];
    return unique(words.map(w=>{w=w.toLowerCase().replace('gray','grey');return w[0].toUpperCase()+w.slice(1);}));
  };
  class SneakerExperience extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const source = this.querySelector('[data-sz-data]');
      if (!source) { requestAnimationFrame(() => this.connectedCallback()); return; }
      this.ready = true;
      this.groups = JSON.parse(source.textContent).groups;
      this.busy = false;
      this.$ = s => this.querySelector(s);
      this.$$ = s => [...this.querySelectorAll(s)];
      this.$$('.sz-tabs button').forEach(b => b.addEventListener('click', () => this.selectGroup(b.dataset.tab)));
      this.$('[data-prev]').addEventListener('click', () => this.photo(-1));
      this.$('[data-next]').addEventListener('click', () => this.photo(1));
      const art = this.$('.sz-art');
      art.addEventListener('keydown', e => { if (['ArrowLeft','ArrowRight'].includes(e.key)) {e.preventDefault(); this.photo(e.key === 'ArrowLeft' ? -1 : 1);} });
      art.addEventListener('pointerdown', e => { this.start = {x:e.clientX,y:e.clientY};if(e.pointerType==='mouse')art.setPointerCapture(e.pointerId); });
      art.addEventListener('pointerup', e => { if (this.start) { const x = e.clientX-this.start.x, y=e.clientY-this.start.y; if (Math.abs(x)>45 && Math.abs(x)>Math.abs(y)) this.photo(x>0?-1:1); } this.start=null; });
      art.addEventListener('pointercancel', () => { this.start = null; });
      this.$('.sz-main-image').addEventListener('dragstart', e => e.preventDefault());
      this.$('.sz-add').addEventListener('click', () => this.add());
      this.$('.sz-finder').addEventListener('submit', e => { e.preventDefault(); this.find(); });
      this.$('[data-clear]').addEventListener('click', () => {this.$('.sz-finder').reset();this.$('.sz-results').hidden=true;});
      this.$('[data-forget]').addEventListener('click', () => { try {localStorage.removeItem('sz-recent-v1');}catch(_){} this.$('.sz-recent').hidden=true; });
      this.addEventListener('keydown', e => { if (e.key === 'Escape') this.$$('.sz-hotspot[open]').forEach(d => {d.open=false; d.querySelector('summary').focus();}); });
      this.$$('.sz-hotspot').forEach(d => d.addEventListener('toggle', () => { if (d.open) this.$$('.sz-hotspot').forEach(other => {if(other!==d) other.open=false;}); }));
      this.selectGroup(this.groups.find(g => g.products.length)?.id || this.groups[0]?.id);
      this.populateFinder(); this.recent();
    }
    selectGroup(id) {
      const g = this.groups.find(g => g.id===id); if (!g) return;
      this.group = g;
      this.$$('.sz-tabs button').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.tab===id)));
      this.$('.sz-browse').href=g.url;
      const pairs=this.$('.sz-pairs'); pairs.replaceChildren();
      g.products.forEach((p,i) => {
        const b=button(''); b.setAttribute('aria-label',p.title); b.title=p.title;
        if(p.images[0]){const img=new Image(); img.src=p.images[0];img.alt='';img.loading='lazy';b.append(img);}else{b.textContent=p.title;}
        b.addEventListener('click',()=>this.selectProduct(i)); pairs.append(b);
      });
      this.selectProduct(0);
    }
    selectProduct(i) {
      this.productIndex=i;this.product=this.group.products[i];this.imageIndex=0;
      this.$$('.sz-pairs button').forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));
      const p=this.product;
      this.$('.sz-buy').hidden=!p;this.$('.sz-empty').hidden=!!p;
      this.$('.sz-gallery-nav').hidden=!p;this.$('.sz-hint').hidden=!p;
      this.$('.sz-options').replaceChildren();this.$('.sz-status').textContent='';this.$('.sz-cart-link').hidden=true;
      if(!p){this.$('.sz-main-image').hidden=true;return;}
      this.$('[data-vendor]').textContent=p.vendor;
      this.$('[data-product-link]').textContent=p.title;this.$('[data-product-link]').href=p.url;
      const first=p.variants.find(v=>v.available)||p.variants[0];
      this.selected=first ? [...first.options] : [];
      const si=sizeIndex(p);
      // Require a deliberate size selection, keeping other dimensions initially valid.
      if(si>=0) this.selected[si]=null;
      p.options.forEach((name,oi)=>{
        if(p.options.length===1 && name==='Title' && first?.options[0]==='Default Title') return;
        const field=document.createElement('fieldset'),legend=document.createElement('legend');legend.textContent=name;field.append(legend);
        const values=document.createElement('div');values.className='sz-option-values';
        unique(p.variants.map(v=>v.options[oi])).forEach(value=>{
          const b=button(value);b.dataset.option=oi;b.dataset.value=value;
          b.addEventListener('click',()=>{
            this.selected[oi]=value;
            // A colour change can invalidate the size. Reset dependent dimensions to a real combination.
            if(oi!==si){ const match=p.variants.find(v=>v.available && v.options[oi]===value); if(match){this.selected=[...match.options]; if(si>=0)this.selected[si]=null;} }
            const match=p.variants.find(v=>v.image && v.options[oi]===value);
            if(match?.image && oi===colourIndex(p)) {const n=p.images.indexOf(match.image);if(n>=0)this.imageIndex=n;this.showImage(match.image);} 
            this.renderOptions();
          });values.append(b);
        });field.append(values);this.$('.sz-options').append(field);
      });
      this.renderOptions();this.showImage();
    }
    renderOptions() {
      const p=this.product;if(!p)return;
      const si=sizeIndex(p);
      this.$$('.sz-option-values button').forEach(b=>{
        const oi=Number(b.dataset.option),val=b.dataset.value;
        // Size availability is specific to the current colour; colour choices stay reachable.
        const available=p.variants.some(v=>v.available && v.options[oi]===val && (oi!==si || this.selected.every((s,j)=>j===oi||s===null||v.options[j]===s)));
        b.disabled=!available;b.setAttribute('aria-pressed',String(this.selected[oi]===val));
        b.title=available?val:val+' — unavailable';
      });
      this.variant=p.variants.find(v=>v.options.every((o,i)=>o===this.selected[i]));
      const display=this.variant||p.variants.find(v=>v.available && this.selected.every((s,i)=>s===null||v.options[i]===s))||p.variants[0];
      this.$('[data-price]').textContent=display?.price||'';
      this.$('[data-compare]').textContent=display?.compare||'';this.$('[data-compare]').hidden=!display?.compare;
      this.$('.sz-price').classList.toggle('is-sale',!!display?.compare);
      const add=this.$('.sz-add');
      add.disabled=this.busy || (!p.requiresPlan && !this.variant?.available);
      add.textContent=this.busy?'Adding…':p.requiresPlan?'VIEW PURCHASE OPTIONS':!p.available?'SOLD OUT':this.variant?.available?'ADD TO BAG':si>=0 && this.selected[si]===null?'CHOOSE YOUR SIZE':'UNAVAILABLE';
      this.$('[data-product-link]').href=p.url+(this.variant?'?variant='+this.variant.id:'');
      if(!this.busy) {this.$('.sz-status').textContent='';this.$('.sz-cart-link').hidden=true;}
    }
    showImage(override) {
      const p=this.product;if(!p)return;const image=this.$('.sz-main-image'),src=override||p.images[this.imageIndex];
      image.hidden=!src;if(src){const changed=image.getAttribute('src')!==src;image.src=src;if(changed)this.matchBackground(src);if(changed && image.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches){image.getAnimations().forEach(a=>a.cancel());image.animate([{opacity:.4,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});}image.alt=p.title+' — photo '+(this.imageIndex+1);}
      this.$('[data-counter]').textContent=String((this.dataset.swipeMode==='products'?this.productIndex:this.imageIndex)+1).padStart(2,'0')+' / '+String(Math.max(1,this.dataset.swipeMode==='products'?this.group.products.length:p.images.length)).padStart(2,'0');
      const count=this.dataset.swipeMode==='products'?this.group.products.length:p.images.length;
      this.$('[data-prev]').disabled=count<2;this.$('[data-next]').disabled=count<2;
      this.$('.sz-hint').hidden=count<2;
    }
    matchBackground(src) {
      this.backgroundCache ||= new Map();
      const apply = colour => {
        // Ignore slow image responses after the shopper switches to another shoe.
        if (this.$('.sz-main-image').getAttribute('src') === src) this.style.setProperty('--sz-photo-background', colour);
      };
      if(this.backgroundCache.has(src)){apply(this.backgroundCache.get(src));return;}
      apply('#f5f5f5');
      // Sample separately so a CDN without CORS can never prevent the product photo loading.
      const probe = new Image(); probe.crossOrigin = 'anonymous';
      probe.onload = () => {
        let colour = '#f5f5f5';
        try {
          const canvas = document.createElement('canvas');canvas.width=32;canvas.height=32;
          const context=canvas.getContext('2d',{willReadFrequently:true});
          context.drawImage(probe,0,0,32,32);
          const pixels=context.getImageData(0,0,32,32).data, samples=[];
          for(const x of [0,1,30,31])for(const y of [0,1,30,31]){
            const i=(y*32+x)*4;
            if(pixels[i+3]<240)continue;
            const rgb=[pixels[i],pixels[i+1],pixels[i+2]];
            // Keep the monochrome interface legible; sample only light neutral backgrounds.
            if(Math.min(...rgb)>=185 && Math.max(...rgb)-Math.min(...rgb)<=20)samples.push(rgb);
          }
          if(samples.length>=8){
            const rgb=[0,1,2].map(c=>{const values=samples.map(v=>v[c]).sort((a,b)=>a-b);return values[Math.floor(values.length/2)];});
            colour='rgb('+rgb.join(',')+')';
          }
        } catch (_) { /* Edge feathering still works without readable image pixels. */ }
        this.backgroundCache.set(src,colour);apply(colour);
      };
      probe.onerror=()=>{this.backgroundCache.set(src,'#f5f5f5');apply('#f5f5f5');};
      probe.src=src;
    }
    photo(delta) {if(this.dataset.swipeMode==='products'){if(!this.group?.products.length)return;this.selectProduct((this.productIndex+delta+this.group.products.length)%this.group.products.length);return;}if(!this.product?.images.length)return;this.imageIndex=(this.imageIndex+delta+this.product.images.length)%this.product.images.length;this.showImage();}
    async add() {
      if(this.busy || !this.product)return;
      if(this.product.requiresPlan){location.assign(this.$('[data-product-link]').href);return;}
      if(!this.variant?.available)return;
      const id=this.variant.id,title=this.product.title;
      this.busy=true;this.renderOptions();this.$('.sz-status').textContent='';
      let message,success=false;
      try {
        const root=window.Shopify?.routes?.root||window.routes?.rootUrl||'/';
        const r=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        const data=await r.json();
        if(!r.ok)throw new Error(typeof data.description==='string'?data.description:'This item could not be added. Please try again.');
        success=true;message=title+' added to your bag.';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      }catch(e){message=e instanceof TypeError?'Connection interrupted. Check your bag before trying again.':e.message;}
      finally {this.busy=false;this.renderOptions();this.$('.sz-status').textContent=message;this.$('.sz-cart-link').hidden=!success;}
    }
    populateFinder() {
      const products=this.groups.flatMap(g=>g.products);
      for(const [name,getIndex] of [['size',sizeIndex],['colour',colourIndex]]){
        const select=this.$('select[name="'+name+'"]');
        const values=unique(products.flatMap(p=>{const i=getIndex(p);return name==='colour'?namedColours(p):(i<0?[]:p.variants.map(v=>v.options[i]));})).sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
        values.forEach(value=>select.add(new Option(value,value)));
        select.disabled=!values.length;
      }
    }
    find() {
      const style=this.$('[name="style"]').value,size=this.$('[name="size"]').value,colour=this.$('[name="colour"]').value;
      const found=new Map();
      this.groups.filter(g=>!style||g.id===style).forEach(g=>g.products.forEach((p,i)=>{
        const si=sizeIndex(p),ci=colourIndex(p);
        const match=p.variants.some(v=>v.available && (!size||(si>=0&&v.options[si]===size)) && (!colour||(ci>=0?v.options[ci]===colour:namedColours(p).includes(colour))));
        if(match&&!found.has(p.id))found.set(p.id,{p,g,i});
      }));
      const area=this.$('.sz-result-grid');area.replaceChildren();
      found.forEach(({p,g,i})=>{
        const card=document.createElement('article');card.className='sz-result-card';
        const a=document.createElement('a');a.href=p.url;
        if(p.images[0]){const im=new Image();im.src=p.images[0];im.alt=p.title;im.loading='lazy';a.append(im);}
        const title=document.createElement('strong');title.textContent=p.title;a.append(title);card.append(a);
        const b=button('Choose options ↗');b.addEventListener('click',()=>{this.selectGroup(g.id);this.selectProduct(i);this.$('.sz-product-name').focus();this.$('.sz-hero').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});card.append(b);area.append(card);
      });
      this.$('[data-results-status]').textContent=found.size?found.size+' available '+(found.size===1?'pair':'pairs')+' in this edit.':'No available pairs match these filters. Try another size or colour.';
      this.$('.sz-results').hidden=false;
      this.$('.sz-results').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }
    recent() {
      try {
        const items=JSON.parse(localStorage.getItem('sz-recent-v1')||'[]');if(!Array.isArray(items))return;
        const grid=this.$('.sz-recent-grid');
        items.slice(0,10).forEach(p=>{
          const url=new URL(p.url,location.origin);if(url.origin!==location.origin)return;
          const a=document.createElement('a');a.href=url.href;
          if(p.image){const u=new URL(p.image,location.origin);if(['https:','http:'].includes(u.protocol)){const img=new Image();img.src=u.href;img.alt='';img.loading='lazy';a.append(img);}}
          const s=document.createElement('span');s.textContent=p.title;a.append(s);grid.append(a);
        });this.$('.sz-recent').hidden=!grid.children.length;
      }catch(_){}
    }
  }
  customElements.define('sz-experience',SneakerExperience);
})();
